import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import {
  AppBarActionsComponent,
  AppBarCloseAction,
  AppBarComponent,
  AppFooterComponent,
  AppPageComponent,
} from "common";
import { SubmissionDetailsGuard } from "../../infrastructure/guards/submission-details.guard";
import { SubmissionDetailsComponent } from "./submission-details.component";
import { NewFormComponent } from "./features/form-details/features/new-form/new-form.component";
import { CanDeactivateSubmissionDetailsGuard } from "../../infrastructure/guards/can-deactivate-submission-details.guard";
import { OAuthGuard } from "../../../../../guards/oauth.guard";
import { SubmissionDetailsAppBarTitleComponent } from "./shared/components/submission-details-app-bar-title/submission-details-app-bar-title.component";

const routes: Routes = [
  {
    path: "submission/new",
    title: "Submission Details – Idea Financial Partner",
    component: AppPageComponent,
    canActivate: [OAuthGuard],
    data: {
      appPage: {
        contentClass: "simple",
        contentAlignment: "center-start",
        contentWithoutPadding: true,
      },
      appBar: {
        stickyDisabled: false,
        closeAction: AppBarCloseAction.BACK,
        logoHidden: true,
        containerClass: "start-center",
      },
    },
    children: [
      {
        path: "",
        outlet: "app-bar",
        component: AppBarComponent,
        children: [
          {
            path: "",
            outlet: "title",
            component: SubmissionDetailsAppBarTitleComponent,
          },
          {
            path: "",
            outlet: "right",
            component: AppBarActionsComponent,
          },
        ],
      },
      {
        path: "",
        component: NewFormComponent,
        canDeactivate: [CanDeactivateSubmissionDetailsGuard],
      },
      {
        path: "",
        outlet: "app-footer",
        component: AppFooterComponent,
        data: {
          appFooter: {
            full: true,
          },
        },
      },
    ],
  },
  {
    path: "submission/:id",
    title: "Submission Details – Idea Financial Partner",
    component: AppPageComponent,
    canActivate: [OAuthGuard, SubmissionDetailsGuard],
    data: {
      appPage: {
        contentClass: "simple",
        contentAlignment: "center-start",
        contentWithoutPadding: true,
      },
      appBar: {
        stickyDisabled: false,
        closeAction: AppBarCloseAction.BACK,
        logoHidden: true,
        containerClass: "start-center",
      },
    },
    children: [
      {
        path: "",
        outlet: "app-bar",
        component: AppBarComponent,
        children: [
          {
            path: "",
            outlet: "title",
            component: SubmissionDetailsAppBarTitleComponent,
          },
          {
            path: "",
            outlet: "right",
            component: AppBarActionsComponent,
          },
        ],
      },
      {
        path: "",
        component: SubmissionDetailsComponent,
        canDeactivate: [CanDeactivateSubmissionDetailsGuard],
      },
      {
        path: "",
        outlet: "app-footer",
        component: AppFooterComponent,
        data: {
          appFooter: {
            full: true,
          },
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SubmissionDetailsRoutingModule {}
